import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xYnZoaGpxMCB7CiAgcGFkZGluZzogMjFweDsKICBvdmVyZmxvdzogYXV0bzsKfQ';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xYnZoaGpxMCA-ICogewogIGZsZXgtc2hyaW5rOiAwOwp9';
export var root = '_1bvhhjq0';